'use strict';

var contentLibraryCtrl = function ($rootScope, $scope, railApi, $state, $stateParams) {

    console.log("state:", $state)

    $scope.generalContents = [];
    $scope.offerContents = [];
    $scope.informationRequestContents = [];
    $scope.regretContents = [];
    $scope.selectedContent = [];
    $scope.generalCount;
    $scope.offerCount;
    $scope.regretCount;
    $scope.archivedCount;
    $scope.informationRequestCount;

    console.log("fsdkjfklsdj")
    
    railApi.index('library_contents', {is_deleted: true}).promise.then(function(data){$scope.archivedContents = data; $scope.archivedCount = data.length;});
    railApi.index('library_contents', {is_deleted: false}).promise.then(function(data){
        console.log(data)
        data.forEach(function(content){
            if (content.category == "general") {
                $scope.generalContents.push(content)
            }
            if (content.category == "offer") {
                $scope.offerContents.push(content)
            }
            if (content.category == "RejectionEmailtype") {
                $scope.regretContents.push(content)
            }
            if (content.category == "informationRequest") {
                $scope.informationRequestContents.push(content)
            }
        })
        $scope.offerCount = $scope.offerContents.length;
        $scope.regretCount = $scope.regretContents.length;
        $scope.generalCount = $scope.generalContents.length;
        $scope.informationRequestCount = $scope.informationRequestContents.length;
        $scope.selectedContent = $scope.generalContents;
        $scope.contentLibraryList = $scope.selectedContent

    })

    $scope.customEmailTemplatesQuery = railApi.index('library_contents', {
        is_system_default: 'false',
        is_deleted: false
    });
    $scope.customEmailTemplates = $scope.customEmailTemplatesQuery.data;
    var preferred_language = $rootScope.preferred_language
    // $scope.companyDepartments = railApi.index('company_departments').data;

    $scope.hgForm = {
        name: {},
        content: {},
        content_notes: '',
        required_languages: [preferred_language]
    };
    // if($state.current.url != '/template/email/add/:id'){
    //     $scope.hgForm.category = 'general'
    // }


    $scope.hgForm.required_languages = ['en'];

    $scope.customSearchFilter = function (content, search, category) { 
        const contList = content
        var newList
        if (category){
            newList = contList.filter(function(data){
                return data.category == category
            })
        }else if(category == ''){
            newList = contList
        }else{
            newList = contList.filter( function(item) {
                var itemStr = JSON.stringify(item).toLowerCase(); 
                var searchStr = search.toLowerCase(); 
                return itemStr.includes(searchStr); 
           }); 
        }

        $scope.contentLibraryList = newList
    };
    

    // $scope.label = {
    //     label: '',
    //     label_desc: ''
    // }

    // $scope.selectButton = "Job.Select"

    // $scope.systemPlaceholders = [{type: 'jobPosting', label: 'jobName'} ,{type: 'jobPosting', label: 'jobNameFr'} ,{type: 'jobPosting', label: 'jobNameEs'} ,{type: 'jobPosting', label: 'clientName'} ,
    //                           {type: 'candidate', label: 'user.name.first'} ,{type: 'candidate', label: 'user.name.last'} ,{type: 'candidate', label: 'user.email'}
    //                          ,{type: 'jobPosting', label: 'job.name'} ,{type: 'jobPosting', label: 'job.name_fr'} ,{type: 'jobPosting', label: 'job.name_es'}
    //                          ,{type: 'jobPosting', label: 'organization.name'} ,{type: 'jobPosting', label: 'contactEmail'} ,{type: 'jobPosting', label: 'contactPhone'}
    //                          ,{type: 'jobPosting', label: 'global.url.protocol'} ,{type: 'jobPosting', label: 'global.url.hostname'}]

    // $scope.existing = false;
    // $scope.addCustom = false;

    // $scope.showEditor = function(){
    //     $scope.label = {
    //         label: '',
    //         label_desc: ''
    //     }
    //     return $scope.addCustom = !$scope.addCustom
    // }

    if ($stateParams.id) {

        railApi.get('library_contents/' + $stateParams.id).promise.then(function (data) {
            $scope.hgForm = data;
            $scope.hgForm.required_languages = data.required_languages
        })
    }

    $scope.redirect = function() {
        $state.go('contentLibraryClone', {id: $scope.hgForm.id});
    }

    // $scope.addCustomLabel = function(label, desc, hgForm){

    //     if(!$scope.systemPlaceholders.some(u => u.label == label ) && !hgForm.custom_placeholder.some(u => u.label == label )){ //<---- this searches the systemPlaceholder array and hgform.customplaceholder array if the label already exist

    //         hgForm.custom_placeholder.push({label: label, description: desc})
    //         $('#labelInput').val('');
    //         $('#labelDesc').val('');
    //         $scope.label.label = ''
    //         $scope.label.label_desc = ''
    //         $scope.addCustom = false;
    //         $scope.existing = false;
    //     }else{
    //         $scope.existing = true;
    //         $scope.addCustom = true;
    //     }

    // }

    // $scope.addCustomLabelEdit = function(label, desc, hgForm, id){
    //     if(_.isEmpty(hgForm.custom_placeholder)){
    //         hgForm.custom_placeholder = []
    //     }

    //     if(!$scope.systemPlaceholders.some(u => u.label == label ) && !hgForm.custom_placeholder.some(u => u.label == label )){ //<---- this searches the systemPlaceholder array and hgform.customplaceholder array if the label already exist

    //         hgForm.custom_placeholder.push({label: label, description: desc})
    //         railApi.put('template_emails/' + id, {custom_placeholder: hgForm.custom_placeholder}, 'template_email').promise.then(function(data){
    //             $('#labelInput').val('');
    //             $('#labelDesc').val('');
    //             $scope.label.label = ''
    //             $scope.label.label_desc = ''
    //             $scope.addCustom = false;
    //             $scope.existing = false;
    //         })

    //     }else{
    //         $scope.existing = true;
    //         $scope.addCustom = true;
    //     }
    // }

    // $scope.copyText = async function(labelText, divId){
    //     await navigator.clipboard.writeText('{{' + labelText + '}}').then(function(){
    //         // console.log("Copied " + labelText + " to clipboard")
    //         $('#'+divId).removeClass("invisibleCopied")
    //         setTimeout(function(){
    //             $('#'+divId).addClass('invisibleCopied')
    //             }, 1000);
    //     })
    // }

    // $scope.removeCustomLabel = function(labelIndex, hgForm){
    //     hgForm.custom_placeholder.splice(labelIndex, 1);
    //     // console.log($scope.hgForm)
    // }

    // $scope.removeCustomLabelEdit = function(labelIndex, hgForm, id){
    //     hgForm.custom_placeholder.splice(labelIndex, 1);
    //     railApi.put('template_emails/' + id, {custom_placeholder: hgForm.custom_placeholder}, 'template_email').promise.then(function(data){
    //         // console.log(data)
    //     })
    // }

    $scope.setTab = function(tab) {
        if (tab == 'offer') {
            $scope.selectedContent = $scope.offerContents;
            $scope.contentLibraryList = $scope.offerContents;

        }
        if (tab == 'regret') {
            $scope.selectedContent = $scope.regretContents;
            $scope.contentLibraryList = $scope.regretContents;

        }
        if (tab == 'general') {
            $scope.selectedContent = $scope.generalContents;
            $scope.contentLibraryList = $scope.generalContents;

        }
        if (tab == 'archived') {
            $scope.selectedContent = $scope.archivedContents;
            $scope.contentLibraryList = $scope.archivedContents;

        }
        if (tab == 'informationRequest') {
            $scope.selectedContent = $scope.informationRequestContents;
            $scope.contentLibraryList = $scope.informationRequestContents;

        }
    }
    
};

module.exports = contentLibraryCtrl;
